import { getArgumentValue } from '../getArgumentValue.js';
import { validateAdvancedFilters } from './validateAdvancedFilters.js';
import { validateConditional } from './validateConditional.js';

export const validateTransform = async ({ step, workflow, status }) => {
  if (!step?.arguments?.stepId) {
    return { status, id: 'go-to-action', message: 'Select step' };
  }

  const workflowSteps = workflow?.steps;
  const stepId = step?.arguments?.stepId;
  const selectedStep = workflowSteps?.find((s) => s?.id === stepId);

  if (!!stepId && !selectedStep) {
    return { status, id: 'go-to-action', message: 'Select existing step' };
  }

  const options = step?.options;

  if (!options || (options.filters?.length === 0 && options.sortCriteria?.length === 0 && options.slices?.length === 0)) {
    return { status: 'valid' };
  }

  // Validate filters
  for (const filter of options.filters || []) {
    const filterValidation = await validateConditional({ condition: filter, status });
    if (filterValidation.status !== 'valid') {
      return { ...filterValidation, id: 'open-filters' };
    }
  }

  if (options?.advancedFilters?.filterSet?.length > 0) {
    const validation = await validateAdvancedFilters({ conditions: options?.advancedFilters, status });
    if (validation.status !== 'valid') {
      return { ...validation, id: 'open-filters' };
    }
  }

  // Validate sorts
  for (const sort of options.sortCriteria || []) {
    if (!sort.field) {
      return { status, id: 'open-sorts', message: 'Add sort field' };
    }
    if (!sort.value) {
      return { status, id: 'open-sorts', message: 'Add sort value' };
    }
  }

  // Validate slices
  for (const slice of options.slices || []) {
    const [from, to] = await Promise.all([
      getArgumentValue({ arg: slice?.from, opts: { format: 'human' } }), //
      getArgumentValue({ arg: slice?.to, opts: { format: 'human' } })
    ]);

    if (!from) {
      return { status, id: 'open-slices', message: 'Add slice start' };
    }
    if (!to) {
      return { status, id: 'open-slices', message: 'Add slice end' };
    }
  }

  return { status: 'valid' };
};
